<script setup>
/* eslint-env jquery */
import { onMounted, onUnmounted, ref } from 'vue';

const props = defineProps({ maxWidth: { type: String, default: '80%' } });
const modalBaseRef = ref();

const emit = defineEmits(['opened', 'closed']);

function show() {
  $(modalBaseRef.value).modal('show');
}

function hide() {
  $(modalBaseRef.value).modal('hide');
}

function onOpened() {
  emit('opened');
}

function onClosed() {
  emit('closed');
}

onMounted(() => {
  if (modalBaseRef.value) {
    $(modalBaseRef.value).on('hidden.bs.modal', onClosed);
    $(modalBaseRef.value).on('shown.bs.modal', onOpened);
  }
});

onUnmounted(() => {
  $(modalBaseRef.value).off('hidden.bs.modal', onClosed);
  $(modalBaseRef.value).off('shown.bs.modal', onOpened);
});

defineExpose({ show, hide });
</script>

<template>
  <div ref="modalBaseRef" class="modal inmodal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg" :style="'max-width:' + props.maxWidth + ';'">
      <div class="modal-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
